import React, { useContext, useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { TODIS_PRIMARY_SUBMIT_BTN } from "../../components/Buttons";
import arrow from "../../assets/icons/arrow-white.svg";
import { Link } from "react-router-dom";
import Swal from 'sweetalert2'
import AuthContext from '../../auth/authContext';
import AuthService from "../../HttpService/AuthService";


const TODIS_CHANGE_PASSWORD_FORM = () => {
    const {user} = useContext(AuthContext);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [formSubmitted, setFormSubmitted] = useState(false);

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const handleConfirmPasswordChange = (event) => {
        setConfirmPassword(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setFormSubmitted(true);
    
        if (password === confirmPassword && password !== '') {
            // Mostrar Swal de carga después de 1 segundo
            const loadingSwalTimeout = setTimeout(() => {
                Swal.fire({
                    title: 'Processing...',
                    text: 'Please wait while we process your request.',
                    allowOutsideClick: false,
                    //showCancelButton: true,
                    //cancelButtonText: 'Close',
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
            }, 5);
    
            try {
                await new AuthService().changePassword(user.username, password);
                // Cerrar Swal de carga si se muestra
                clearTimeout(loadingSwalTimeout);
                Swal.close();
    
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'You have successfully changed your password',
                    showConfirmButton: true,
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = `/TODIS-APP/`;
                    }
                });
            } catch (error) {
                // Manejar errores y cerrar Swal de carga si se muestra
                clearTimeout(loadingSwalTimeout);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "An unexpected error occurred while changing your password.",
                    showConfirmButton: true
                });
            }
        }
    };
    

    return (
        <Container fluid className="todis-sign-in-form-wrapper">
            <Col className="p-4">
                <Link to="/TODIS-APP">
                    <button className="text-center todis-header mb-2">Back to Landing</button>
                </Link>
            </Col>
            <h2 className="text-center todis-header mb-5">Change your password</h2>

            <Form className="mt-5" onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Control type="password" placeholder="NEW PASSWORD" style={text_styles} className="todis-forms" onChange={handlePasswordChange} value={password} />

                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
                    <Form.Control type="password" placeholder="CONFIRM PASSWORD" style={text_styles} className="todis-forms" onChange={handleConfirmPasswordChange} value={confirmPassword} />
                </Form.Group>
                {formSubmitted && ((password !== confirmPassword && confirmPassword !== '') || (password !== '' && confirmPassword === '')) ? (
                    <div>
                        <h5 style={{ color: "red", textAlign: "center" }}>Passwords do not match</h5>
                    </div>
                ) : null}
                {formSubmitted && password === '' && confirmPassword === '' ? (
                    <div>
                        <h5 style={{ color: "red", textAlign: "center" }}>Passwords cannot be empty</h5>
                    </div>
                ) : null}
                <Row className="mt-5 d-flex justify-content-center">
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="p-2"><TODIS_PRIMARY_SUBMIT_BTN title="Change password" image={arrow} type="submit" /></Col>
                </Row>
            </Form>

        </Container>
    );  
}

export default TODIS_CHANGE_PASSWORD_FORM;

const text_styles = {
    borderRadius: '19px',
    padding: '1rem',
    marginTop: '2rem',
    border: '0px',
    color: '#0B4CA1'
}